module.exports = __webpack_public_path__ + "static/assets/d2f09d1c94d9e208bd96cdc14afafd4b.svg";